import React, { Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";
import InfoContentVert from "./profileInfo/infoContentVert";
import "../../assets/css/scss/section/player/_profileInfoSection.scss";
// import PlayerImageTitleVert from '../image/playerImageTitleVert';
import InfoContentHoriz from "./profileInfo/infoContentHoriz";
import { Image } from "react-bootstrap";
import "../../assets/css/scss/component/image/_playerProfileBackground.scss";
import preventRightClick from "../../common/preventRightClick";
import {
  BASEBALL_STATISTICS,
  BASEBALL_TEAM_STATISTICS,
} from "../../constant/match";
import { IReduxStateData } from "../../interfaces/redux";
import { useSelector } from "react-redux";

export default function ProfileInfoSection(props: any) {
  console.log("profile >", props);
  const data = props?.data;
  const isTeam = props?.isTeam ? true : false;
  console.log("isTeam >", isTeam, props);
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  let name = "";
  let image = "";
  let infoHorizData: any = {
    title: "",
    data: [],
    isDisplay: false,
  };
  data.infoHorizData = infoHorizData;
  if (isTeam) {
    if (data?.name) {
      name = data?.name.split(" ")[0];
    }
    if (data?.flag) {
      image = data?.flag;
    } else {
      image =
        "https://res.cloudinary.com/deq61wdj1/image/upload/v1770574250/lcd/team_images/default-team-logo_pqvbz8.png";
    }
    if (data?.wg) {
      infoHorizData.data.push({
        title: "WG",
        value: data.wg,
        rankTitle: "",
        rankSup: "",
      });
    }

    if (data?.lg) {
      infoHorizData.data.push({
        title: "LG",
        value: data.lg,
        rankTitle: "",
        rankSup: "",
      });
    }
    if (data?.rs) {
      infoHorizData.data.push({
        title: "RS",
        value: data.rs,
        rankTitle: "",
        rankSup: "",
      });
    }
    if (data?.ra) {
      infoHorizData.data.push({
        title: "RA",
        value: data.ra,
        rankTitle: "",
        rankSup: "",
      });
    }
    infoHorizData.isDisplay = true;
  } else {
    if (data?.player_name) name = data?.player_name.split(" ")[0];
    if (data?.player_image) {
      image = data?.player_image;
    } else {
      image =
        "https://res.cloudinary.com/deq61wdj1/image/upload/v1770564919/lcd/player_images/default-player-image_vnopgp.png";
    }
  }
  console.log("llll >", BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang]);
  return (
    <section className="profile-section-one">
      <Container className="profile-section-container">
        <Row className="justify-content-around align-items-center">
          <Col xl={4} md={6}>
            {/* <PlayerImageTitleVert /> */}
            <div
              className="profile-background-svg-image"
              onContextMenu={(e) => preventRightClick(e)}
            >
              {/* <Image
                className="first-image w-100"
                src="/assets/images/player-background.png"
                alt="player"
              />
              <div className="player-img">
                <Image src="/assets/images/player-banner.png" fluid />
              </div> */}
              <Image
                className="first-image"
                src="/assets/images/player-background-1.svg"
                alt="player"
              />
              <Image
                className="other-image"
                src="/assets/images/player-background-2.svg"
                alt="player"
              />
              <Image
                className="other-image third-image"
                src="/assets/images/player-background-3.svg"
                alt="player"
              />
              <Image
                className="other-image fourth-image"
                src="/assets/images/player-background-4.svg"
                alt="player"
              />
              <div className="title">
                <h1>{name}</h1>
              </div>
              <Image src={image} className="other-image player-img" />
              {isTeam ? (
                <div className="player-score d-flex align-items-center justify-content-between team-details-info">
                  <div className="player-number">
                    <span className="d-block player-title">
                      {
                        BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang][
                          "fullname"
                        ]
                      }
                    </span>
                    <span className="h6">{`${data?.fullname || ""}`}</span>
                  </div>
                  <div className="player-position">
                    <span className="position d-block player-title">
                      {
                        BASEBALL_TEAM_STATISTICS["team_profile"][selectedLang][
                          "owner"
                        ]
                      }
                    </span>
                    <span className="h6 text-capitalize">
                      {data?.owner || "-"}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="player-score d-flex align-items-center justify-content-between">
                  <div className="player-number">
                    <span className="d-block player-title text-capitalize">
                      {
                        BASEBALL_STATISTICS["player_profile"][selectedLang][
                          "in_at"
                        ]
                      }
                    </span>
                    <span className="h6">{`${
                      data?.player_jersey_number || ""
                    }`}</span>
                  </div>
                  <div className="player-position">
                    <span className="position d-block player-title text-capitalize">
                      {
                        BASEBALL_STATISTICS["player_profile"][selectedLang][
                          "position"
                        ]
                      }
                    </span>
                    <span className="h6 text-capitalize">
                      {data?.player_position || ""}
                    </span>
                  </div>
                  <div className="country">
                    <span className="d-block player-title text-capitalize">
                      {
                        BASEBALL_STATISTICS["player_profile"][selectedLang][
                          "country"
                        ]
                      }
                    </span>
                    <span className="img">
                      <Image
                        src={
                          data?.logo || data?.flag
                            ? data?.logo || data?.flag
                            : "https://lcd-images-public.s3.ap-south-1.amazonaws.com/tp_images/default-team-flag-image.jpg"
                        }
                        fluid
                      />
                      {/* <Image src="https://lcd-images-public.s3.ap-south-1.amazonaws.com/tp_images/default-team-flag-image.jpg" fluid /> */}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </Col>
          {!isTeam ? (
            <Col md={6} xl={4} className="align-items-center mt-4 mt-md-0">
              <InfoContentVert data={data} />
            </Col>
          ) : null}
          <Col md={12} xl={4} className="align-items-center mt-4 mt-xl-0">
            <InfoContentHoriz isTeam={isTeam} data={data} />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
